import { ChangeDetectorRef, Component, numberAttribute } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UserType } from 'src/app/enums/user-type';
import { IWizard } from 'src/app/interfaces/iwizard';
import { User } from 'src/app/interfaces/user';
import { WizardSteps } from 'src/app/interfaces/wizard-steps';
import { EnrollmentService } from 'src/app/services/enrollment.service';
import { GeneralService } from 'src/app/services/general.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-j-user-access-user-info',
    templateUrl: './j-user-access-user-info.component.html',
    styleUrls: ['./j-user-access-user-info.component.scss'],
    standalone: false
})
export class JUserAccessUserInfoComponent {
     rowInEdit: number = -3;
     _emailIsDup: number = -3;
     _emailTesting: number = -3;
     _billingIsAdmin: boolean = false;
     isAdd: boolean = false;
     emailValidate: boolean = false;
     showDifferentEmailError: boolean = false;
     showErrorForDupsOnload: string[] = [];
     userType = UserType;
     removeIndex: number = -1;
     inNewUser: boolean = false;
     companyInfo!: FormGroup;
     userInfo!: FormGroup;

     minEmailLength: number = 5;

     constructor(public generalService: GeneralService, 
          public enrollmentService: EnrollmentService, 
          private modalService: NgbModal, private cdr: ChangeDetectorRef) { 
          }

     wizardObj: IWizard = {
          steps: [
               { step: 1, text: 'Welcome' } as WizardSteps,
               { step: 2, text: 'Company Information' } as WizardSteps,
               { step: 3, text: 'User Accounts' } as WizardSteps,
               { step: 4, text: 'Review' } as WizardSteps,
               { step: 5, text: 'Contract Documents' } as WizardSteps,
               { step: 6, text: 'Submit' } as WizardSteps,
               { step: 7, text: 'Billing Information' } as WizardSteps
          ]
     }

     ngOnInit(): void {
          //we are going to keep the users local to 

          this.companyInfo = new FormGroup({
               firstName: new FormControl(this.enrollmentService.powerUser!.firstName, [
                    Validators.required,
                    Validators.maxLength(50),
                    Validators.pattern(/^([a-zA-Z ']*)$/)
               ]),
               lastName: new FormControl(this.enrollmentService.powerUser!.lastName, [
                    Validators.required,
                    Validators.maxLength(50),
                    Validators.pattern(/^([a-zA-Z ']*)$/)
               ]),
               email: new FormControl(this.enrollmentService.powerUser!.email, [
                    Validators.required,
                    Validators.maxLength(50),
                    Validators.pattern(/^[-a-z0-9'!_-}{\'?]+(\.[-a-z0-9'!_-}{\'?]+)*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9_-]+\.)+[a-zA-Z]{2,}))$/i)
               ]),
               firstNameBilling: new FormControl(this.enrollmentService.billingUser!.firstName, [
                    (this.enrollmentService.billingUserSame !== 'true' ? Validators.required : Validators.nullValidator),
                    Validators.maxLength(50),
                    Validators.pattern(/^([a-zA-Z ']*)$/)
               ]),
               lastNameBilling: new FormControl(this.enrollmentService.billingUser!.lastName, [
                    (this.enrollmentService.billingUserSame !== 'true' ? Validators.required : Validators.nullValidator),
                    Validators.maxLength(15000),
                    Validators.pattern(/^([a-zA-Z ']*)$/)
               ]),
               emailBilling: new FormControl(this.enrollmentService.billingUser!.email, [
                    (this.enrollmentService.billingUserSame !== 'true' ? Validators.required : Validators.nullValidator),
                    Validators.maxLength(100),
                    Validators.pattern(/^[-a-z0-9'!_-}{\'?]+(\.[-a-z0-9'!_-}{\'?]+)*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9_-]+\.)+[a-zA-Z]{2,}))$/i)
               ])
          });


          this.buildDupList();
          setTimeout(() => this.scrollToTop(), 500);
     }

     get firstName() { return this.companyInfo!.get('firstName'); }
     get lastName() { return this.companyInfo!.get('lastName'); }
     get firstNameBilling() { return this.companyInfo!.get('firstNameBilling'); }
     get lastNameBilling() { return this.companyInfo!.get('lastNameBilling'); }
     get email() { return this.companyInfo!.get('email'); }
     get emailBilling() { return this.companyInfo!.get('emailBilling'); }

     get firstNameUser() { return this.userInfo!.get('firstName'); }
     get lastNameUser() { return this.userInfo!.get('lastName') }
     get emailUser() { return this.userInfo!.get('email'); }

     testEmail(dex: number) {

          
          this._emailIsDup = -3;
          if ((dex === -2 && this.companyInfo!.get('email')?.valid) || 
               (dex === -1 && this.companyInfo!.get('emailBilling')?.valid)  || 
               (dex > -1 && this.userInfo!.get('email')?.valid) ) {
               
               const emailToTest = (dex === -2 ? this.companyInfo!.get('email')?.value : 
                    (dex === -1 ? this.companyInfo!.get('emailBilling')?.value : this.userInfo!.get('email')?.value))

               //we need to test other emails that have already been added to the list but not the DB.
               const findEmailInUserListIndex = this.enrollmentService.users?.findIndex(u => u.email.toLocaleLowerCase() === emailToTest.toString()) || -1;
               if(findEmailInUserListIndex > -1 && findEmailInUserListIndex !== dex){
                    //we know that the email we are working on matches one that was already added.
                    this._emailIsDup = dex;
                    this._emailTesting = -3;
               }else if(dex === -2 && emailToTest.toLocaleLowerCase() === this.companyInfo!.get('emailBilling')?.value.toLocaleLowerCase() ){
                    //we know that the billing email matches the email we are testing 
                    this._emailIsDup = dex;
                    this._emailTesting = -3;
               }else if(dex === -1 && emailToTest.toLocaleLowerCase() === this.companyInfo!.get('email')?.value.toLocaleLowerCase() ){
                    //we know that the Primary email matches the email we are testing 
                    this._emailIsDup = dex;
                    this._emailTesting = -3;
               }
               this._emailTesting = dex;
               if(this._emailIsDup === -3){
                    this.enrollmentService.testEmail(emailToTest)
                         .subscribe((v: any) => {
                              {
                                   if (v === 'true') {
                                        this._emailIsDup = dex;
                                   } else {
                                        this._emailIsDup = -3;
                                   }
                                   this._emailTesting = -3;
                              }
                         }
                    );
               }
          }
     }


     notUnique(dex: number) {
          if(this.userInfo  !== undefined && this.emailUser && this.emailUser !== undefined){
               if(this.emailUser!.value === ""){
                    return false;
               }
               if (this.email!.value.toString().toLocaleLowerCase() === this.emailUser!.value.toString().toLocaleLowerCase()) {
                    return true;
               }

               if (this.emailBilling && this.emailBilling!.value.toString().toLocaleLowerCase() === this.emailUser!.value.toString().toLocaleLowerCase()) {
                    return true;
               }
               for (let i: number = 0; i < this.enrollmentService.users!.length; i++) {
                    if (i !== dex) {
                         if (this.enrollmentService.users![i].email.toString().toLocaleLowerCase() === this.emailUser!.value.toString().toLocaleLowerCase()) {
                              return true;
                         }
                    }
               }
          }
          return false;
     }

     emailIsDup(dex: number) {
          return (dex === this._emailIsDup);
     }

     removeUser(dex: number) {
          if(dex === -1){
               this.enrollmentService.iniBillingUser();
               this.enrollmentService.billingUserSame = "true";
               this.companyInfo.removeControl('firstNameBilling');
               this.companyInfo.removeControl('lastNameBilling');
               this.companyInfo.removeControl('emailBilling');
          }else{
               this.enrollmentService.users!.splice(dex, 1);
          }
          this.buildDupList();
     }

     get getRowInEdit(){
          return this.rowInEdit;
     }

     inEdit(dex: number) {
          if(this.rowInEdit === -3 && this._emailTesting === -3){
               this.rowInEdit = dex;
               if (this.rowInEdit > -1) {
                    if (this.rowInEdit > -1) {

                         this.userInfo = new FormGroup({
                              firstName: new FormControl(this.enrollmentService.users![this.rowInEdit].firstName, [
                                   Validators.required,
                                   Validators.maxLength(50),
                                   Validators.pattern(/^([a-zA-Z ']*)$/)
                              ]),
                              lastName: new FormControl(this.enrollmentService.users![this.rowInEdit].lastName, [
                                   Validators.required,
                                   Validators.maxLength(50),
                                   Validators.pattern(/^([a-zA-Z ']*)$/)
                              ]),
                              email: new FormControl(this.enrollmentService.users![this.rowInEdit].email, [
                                   Validators.required,
                                   Validators.maxLength(50),
                                   Validators.pattern(/^[-a-z0-9'!_-}{\'?]+(\.[-a-z0-9'!_-}{\'?]+)*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9_-]+\.)+[a-zA-Z]{2,}))$/i)
                              ])
                         });
                    }
               }
               this.cdr.detectChanges();
          }
     }



     addNewRow() {
          this.enrollmentService.addUser();
          this.rowInEdit = this.enrollmentService.users!.length - 1;
          this.userInfo = new FormGroup({
               firstName: new FormControl(this.enrollmentService.users![this.rowInEdit].firstName, [
                    Validators.required,
                    Validators.maxLength(50),
                    Validators.pattern(/^([a-zA-Z ']*)$/)
               ]),
               lastName: new FormControl(this.enrollmentService.users![this.rowInEdit].lastName, [
                    Validators.required,
                    Validators.maxLength(50),
                    Validators.pattern(/^([a-zA-Z ']*)$/)
               ]),
               email: new FormControl(this.enrollmentService.users![this.rowInEdit].email, [
                    Validators.required,
                    Validators.maxLength(50),
                    Validators.pattern(/^[-a-z0-9'!_-}{\'?]+(\.[-a-z0-9'!_-}{\'?]+)*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9_-]+\.)+[a-zA-Z]{2,}))$/i)
               ])
          });
          this.isAdd = true;
     }

     getUniqueIdentifier(propertyName: string, htmlElementType: string, itemDex: number) {
          let id = `${propertyName}_${htmlElementType}_${itemDex}`;

          return id;
     }


     getTranslator(val: string): string {
          let translation: string = this.generalService.getTranslation(val, 'base');
          if (translation === undefined) {
               translation = this.generalService.getTranslation(val, 'base');
          }
          return translation;
     }

     isAdminUpDated(dex:number){
          if(dex < 0){            
               this.companyInfo.markAsDirty();
          }else{
               this.userInfo.markAsDirty();
          }
     }

     

     rowValid(dex: number) {
          if(this._emailTesting !== -3){
               return true;
          }
          if(this.notUnique(dex)){
               return true;
          }else if(dex < 0){
               return  !(this.companyInfo.valid && this.companyInfo.dirty)

          }else{
               return !(this.userInfo.valid && this.userInfo.dirty);
          }

          
     }

     updateUser(dex: number) {
          if(dex === -2){
               this.enrollmentService.powerUser!.firstName = this.companyInfo!.get('firstName')?.value;
               this.enrollmentService.powerUser!.lastName = this.companyInfo!.get('lastName')?.value;
               this.enrollmentService.powerUser!.email = this.companyInfo!.get('email')?.value;
          }else if(dex === -1){
               this.enrollmentService.billingUser!.firstName = this.companyInfo!.get('firstNameBilling')?.value;
               this.enrollmentService.billingUser!.lastName = this.companyInfo!.get('lastNameBilling')?.value;
               this.enrollmentService.billingUser!.email = this.companyInfo!.get('emailBilling')?.value;
          }else{
               this.enrollmentService.users![dex]!.firstName = this.userInfo!.get('firstName')?.value;
               this.enrollmentService.users![dex]!.lastName = this.userInfo!.get('lastName')?.value;
               this.enrollmentService.users![dex]!.email = this.userInfo!.get('email')?.value;
               this.stopAddEditUser();
          }
          this.rowInEdit = -3;
          
          this.isAdd = false;
          this.buildDupList();
     }

     cancelUserEdit(dex: number) {
          if (this.isAdd) {
               this.enrollmentService.users!.pop();
               this._emailTesting = -3;
          } else if (dex === -2) {
               this.companyInfo.controls["firstName"].reset(this.enrollmentService.powerUser!.firstName);
               this.companyInfo.controls["lastName"].reset(this.enrollmentService.powerUser!.lastName);
               this.companyInfo.controls["email"].reset(this.enrollmentService.powerUser!.email);
          } else if (dex === -1) {
               this.companyInfo.controls["firstNameBilling"].reset(this.enrollmentService.billingUser!.firstName);
               this.companyInfo.controls["lastNameBilling"].reset(this.enrollmentService.billingUser!.lastName);
               this.companyInfo.controls["emailBilling"].reset(this.enrollmentService.billingUser!.email);
          } else if(dex > -1){
               this.userInfo.controls["firstName"].reset(this.enrollmentService.users![dex]!.firstName);
               this.userInfo.controls["lastName"].reset(this.enrollmentService.users![dex]!.lastName);
               this.userInfo.controls["email"].reset(this.enrollmentService.users![dex]!.email);
               this.stopAddEditUser();
          }
          this.isAdd = false;
          this.rowInEdit = -3;
          this.cdr.detectChanges();
     }

     private stopAddEditUser(){
          
          this.userInfo.removeControl('firstName');
          this.userInfo.removeControl('lastName');
          this.userInfo.removeControl('email');
     }

     buildDupList() {
          this.showErrorForDupsOnload = [];
          for (let i: number = 0; i < this.enrollmentService.users!.length; i++) {
               if(this.enrollmentService.users![i].email === this.enrollmentService.powerUser?.email){
                    this.showErrorForDupsOnload.push(this.enrollmentService.users![i].email);
               }else if(this.enrollmentService.users![i].email === this.enrollmentService.billingUser?.email){
                    this.showErrorForDupsOnload.push(this.enrollmentService.users![i].email);
               }else{
                    for (let x: number = i+1; x < this.enrollmentService.users!.length; x++) {
                         if(this.enrollmentService.users![i].email === this.enrollmentService.users![x].email){
                              this.showErrorForDupsOnload.push(this.enrollmentService.users![i].email);
                         }
                    }
               }
          }
      }

     removeBillingAlert(dex: number, content:any) {
          this.removeIndex = dex;
          this.modalService.open(content, { ariaLabelledBy: 'removeBillingAlertTitle' });
     }

     getErrorLength() {
          return this.showErrorForDupsOnload.length;
     }

     scrollToTop() {
          window.scrollTo(0, 0);
     }

     pageValid() {
          const isValid = (this.companyInfo.valid  && this.rowInEdit === -3 && this._emailIsDup === -3 && this._emailTesting === -3 && this.getErrorLength() === 0);

          return isValid;
     }

     ngAfterViewInit() {
          window.onbeforeunload = function () {
               return 'You have created an account but not set up billing. Are you sure you wish to exit?';
          }
     }

     disableAdd(){
          const userCount = this.enrollmentService.users!.length + 1 + (this.enrollmentService.billingUserSame !== 'true' ? 1 : 0);
          return userCount > 9;
     }


     ngOnDestroy() {
          this.enrollmentService.saveToLocal();
     }

}